import { useContext } from 'react';
import { WizardContext } from './context';
import type { WizardContextValue, WizardValuesBase } from './types';

export const useWizard = <T extends WizardValuesBase = WizardValuesBase>(): {
  currentStepId: string;
  values: T;
  actions: WizardContextValue<T>['actions'];
} => {
  const context = useContext(WizardContext);

  if (!context) {
    throw new Error('useWizard must be used within a WizardProvider');
  }

  const { state, actions } = context as WizardContextValue<T>;

  return {
    currentStepId: state.currentStepId,
    values: state.values,
    actions,
  };
};
